// extracted by mini-css-extract-plugin
export var infoRow = "_vd-2";
export var labelContainer = "_vd-0";
export var rightInfo = "_vd-1";